export default __webpack_public_path__ + "static/media/2.1a12fa54.jpg";